"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentSchemaProperties = exports.AppointmentSchema = exports.GroupSchedulerInformation = exports.IntegrationInfoSchema = exports.OutcomeHistorySchema = exports.AppointmentReschedulingOptionsSchema = exports.AppointmentOutcomeSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const integration_1 = require("./integration");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
const AppointmentStatusEnum = zod_1.z.enum([
    "confirmed",
    "cancelled",
    "declined",
    "maybe",
    "pending",
    "deleted",
    "shared",
    "tentative",
    "accepted",
    "needsAction",
]);
const FormReminderSchema = zod_1.z.object({
    formId: zod_1.z.string().optional(),
});
const AppointmentLocationEnum = zod_1.z.enum([
    "google-call",
    "zoom-call",
    "video-call",
    "voice-call",
    "outgoing-call",
    "in-person",
    "skype-consumer-call",
    "skype-business-call",
    "teams-call",
]);
const AppointmentDashboardSchema = zod_1.z.object({
    payments: zod_1.z.literal("dismissed").optional(),
});
const AppointntEventDataSchema = zod_1.z.object({
    icon: zod_1.z.string(),
    attendeesLimit: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    productId: zod_1.z.string().optional(),
    smartActions: zod_1.z.array(smart_action_schema_1.SmartActionSchema).optional(),
});
exports.AppointmentOutcomeSchema = zod_1.z.object({
    outcomeId: zod_1.z.string(),
    createdBy: zod_1.z.string(),
    note: zod_1.z.string().optional(),
    origin: zod_1.z.string().optional(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    isAcceptedByPackage: zod_1.z.boolean().optional(),
});
exports.AppointmentReschedulingOptionsSchema = zod_1.z.object({
    allowedActions: zod_1.z.enum(["none", "cancel"]),
    minimumNotice: zod_1.z.object({ duration: zod_1.z.number() }),
    reasonRequired: zod_1.z.boolean(),
});
exports.OutcomeHistorySchema = zod_1.z.object({
    outcomeId: zod_1.z.string().nullable(),
    date: zod_1.z.date(),
    memberId: zod_1.z.string(),
});
exports.IntegrationInfoSchema = zod_1.z.object({
    memberId: zod_1.z.string(),
    email: zod_1.z.string(),
    integrationId: zod_1.z.string().optional(),
    provider: integration_1.ProviderSchema,
});
exports.GroupSchedulerInformation = zod_1.z.object({
    groupSchedulerId: zod_1.z.string(),
    timeslotId: zod_1.z.string(),
    memberId: zod_1.z.string().optional(),
    recurring: zod_1.z.boolean().optional(),
    groupSchedulerType: zod_1.z.enum(["ongoing", "curriculum"]).optional(),
});
exports.AppointmentSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    start: zod_1.z.date(),
    end: zod_1.z.date(),
    timeZone: zod_1.z.string().optional(),
    status: AppointmentStatusEnum,
    deletedBy: zod_1.z
        .object({
        memberId: zod_1.z.string(),
        date: zod_1.z.date(),
        deletedSeries: zod_1.z.boolean().optional(),
    })
        .optional(),
    paymentId: zod_1.z.string().optional(),
    paymentIds: zod_1.z.array(zod_1.z.string()).optional(),
    packageInstanceId: zod_1.z.string().optional().nullable(),
    packageInstanceIds: zod_1.z.array(zod_1.z.string()).optional(),
    formId: zod_1.z.string().optional(),
    formAfter: FormReminderSchema.optional(),
    formBefore: FormReminderSchema.optional(),
    gcal: zod_1.z
        .object({
        event: zod_1.z.any(),
    })
        .optional(),
    contactId: zod_1.z.string().nullable().optional(),
    contactIds: zod_1.z.array(zod_1.z.string()).optional(),
    locationType: AppointmentLocationEnum.optional(),
    locationMemberId: zod_1.z.string().optional(),
    repeat: zod_1.z.any(),
    ISOstart: zod_1.z.string().optional(),
    ISOend: zod_1.z.string().optional(),
    dashboard: AppointmentDashboardSchema.optional(),
    noteIds: zod_1.z.array(zod_1.z.string()).optional(),
    slug: zod_1.z.string().optional(),
    location: zod_1.z.string().optional().nullable(),
    gcalCalendar: zod_1.z.any().optional(),
    googleAccountId: zod_1.z.string().nullable().optional(),
    eventData: AppointntEventDataSchema.optional(),
    groupId: zod_1.z.string().optional(),
    isEvent: zod_1.z.boolean().optional(),
    hidden: zod_1.z.boolean().optional(),
    availabilityId: zod_1.z.string().optional(),
    recurring: zod_1.z.boolean().optional(),
    allDayEvent: zod_1.z.boolean().optional(),
    syncCreated: zod_1.z.boolean().optional(),
    syncLocked: zod_1.z
        .object({
        calendarId: zod_1.z.string(),
        lockedAt: zod_1.z.date(),
        lockedBy: zod_1.z.string(),
        start: zod_1.z.date(),
    })
        .optional()
        .nullable(),
    origin: zod_1.z.string().optional(),
    smartActions: zod_1.z.any().optional(),
    outcome: exports.AppointmentOutcomeSchema.optional().nullable(),
    attendeeOutcomes: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({
        outcome: exports.AppointmentOutcomeSchema.nullable(),
        outcomeHistory: zod_1.z.array(exports.OutcomeHistorySchema),
    }))
        .optional(),
    outcomeHistory: zod_1.z.array(exports.OutcomeHistorySchema).optional(),
    packageInstanceCycle: zod_1.z.number().nullable().optional(),
    clientParentId: zod_1.z.string().optional().nullable(),
    internalFormIds: zod_1.z.array(zod_1.z.string()).optional(),
    reschedulingOptions: exports.AppointmentReschedulingOptionsSchema.optional(),
    memberIds: zod_1.z.array(zod_1.z.string()).optional(),
    // @TODO: all props below are deprecated and not been used.
    //        It was added here to make the schema validation works, and
    //        all of them should be deleted once the database is fixed without them
    reminders: zod_1.z.any().optional(),
    groupSchedulerTimeslotId: zod_1.z.string().optional(),
    customEventInformation: zod_1.z
        .object({
        eventId: zod_1.z.string(),
        organizer: zod_1.z.string(),
    })
        .optional(),
    /* Unique vendor based id, unique for each appointment, standard id can't be used,
    because google changes ids of recurring appointments when you modify start time.
    It is used as the final check to prevent duplicate appointments */
    vendorId: zod_1.z.string().optional().nullable(),
    vendorSeriesId: zod_1.z.string().optional().nullable(),
    organizerId: zod_1.z.string().optional(),
    calendarId: zod_1.z.string().optional(),
    //TODO!: improve model
    attendees: zod_1.z.array(zod_1.z.any()).optional(),
    provider: integration_1.ProviderSchema.optional(),
    metadata: zod_1.z.any().optional(),
    groupSchedulerInformation: exports.GroupSchedulerInformation.optional(),
    groupSchedulerTimslotId: zod_1.z.string().optional(),
    integrationInfo: exports.IntegrationInfoSchema.optional(),
});
exports.AppointmentSchemaProperties = {
    collectionName: "appointments",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=appointment-schema.js.map